import { thunkSetWall } from '../../tac/tacThunks';
import {
  selectCeilingHeightBasedOnMarket,
  selectWallSize,
  selectTac,
} from '../../tac/tacSelectors';
import { TacModel } from '../../tac/tacTypes';
import tacHelpers from '../../tac/tacHelpers';
import { selectDraftCeilingHeight } from './ceilingHeightSelectors';
import { selectUseMetric } from '../../dexfSettings/dexfSettingsSelectors';
import { actionSetDraftCeilingHeight } from './ceilingHeightActions';
import { parseInt } from 'lodash';
import { KEYS } from '../../../constants';
import { cm, inches } from '../../../util/measures';
import { GetState } from '../../../generalTypes';
import constants from '../../../settings/constants';

export const thunkRecountAsMm =
  (value: number) => (dispatch: any, getState: GetState) => {
    const shouldUseMetric = selectUseMetric(getState());
    return shouldUseMetric ? cm.toMm(value) : inches.toMm(value);
  };

export const getCuredHeight = (height: number, tac: TacModel | null) => {
  const wallResizingLimits = tacHelpers.getWallResizingLimits(tac);
  const maxHeight = constants.WALL.height.max;
  const minHeight = Math.max(
    wallResizingLimits.max.y,
    constants.WALL.height.min
  );

  if (height < minHeight) return minHeight;
  if (height > maxHeight) return maxHeight;

  return height;
};

export const thunkSaveWallHeight =
  () => (dispatch: any, getState: GetState) => {
    const { width } = selectWallSize(getState());
    const draftHeight = selectDraftCeilingHeight(getState());
    const valueAsMm = dispatch(thunkRecountAsMm(draftHeight));
    const { height: currentHeight } = selectWallSize(getState());
    const tac = selectTac(getState());
    const curedHeight = getCuredHeight(valueAsMm, tac);
    const newDraftHeight = selectCeilingHeightBasedOnMarket(
      getState(),
      curedHeight
    );
    const wallHeightChanged = () => currentHeight !== curedHeight;
    dispatch(
      actionSetDraftCeilingHeight(newDraftHeight, {
        isPersistent: wallHeightChanged(),
      })
    );
    dispatch(
      thunkSetWall(
        {
          width,
          height: curedHeight,
        },
        { isPersistent: wallHeightChanged() }
      )
    );
  };

export const thunkSetVirtualKeyboardHeightInput =
  (keyCode: string) => (dispatch: any, getState: GetState) => {
    const currentHeight = selectDraftCeilingHeight(getState());
    const parsedInputValue = parseInt(keyCode, 10);
    const addingNumber = !isNaN(parsedInputValue);
    const currentHeightIsZero = currentHeight === 0 && addingNumber;
    const allCharsRemoved =
      `${currentHeight}`.length - 1 <= 0 && keyCode === KEYS.BACKSPACE;
    const removingCharacter = keyCode === KEYS.BACKSPACE;

    const handleBackspaceKey = () => {
      const newHeight = parseInt(`${currentHeight}`.slice(0, -1));
      dispatch(actionSetDraftCeilingHeight(newHeight));
    };

    const handleNumberKey = () => {
      const newHeight = parseInt(`${currentHeight}${keyCode}`);
      dispatch(actionSetDraftCeilingHeight(newHeight));
    };

    const handleZero = () => dispatch(actionSetDraftCeilingHeight(0));

    const handleStartingFromZero = () =>
      dispatch(actionSetDraftCeilingHeight(parsedInputValue));

    if (currentHeightIsZero) return handleStartingFromZero();
    if (allCharsRemoved) return handleZero();
    if (addingNumber) return handleNumberKey();
    if (removingCharacter) return handleBackspaceKey();
  };
